import AdminConfigTractorNozzles from './AdminConfigTractorNozzles';
export default AdminConfigTractorNozzles;
